<template>
    <div>
        <div class="header">Add a response</div>

        <form @submit.prevent="onSubmit" class="form response-form" ref="form">
            <fieldset class="form__group">
                <div class="toggle-group">
                    <img :src="`/images/avatar/${user.id}`" alt="" class="avatar avatar--small" v-if="formData.ableToHelp === null">
                    <input id="able-to-help" name="able-to-help" class="toggle" type="radio" :value="true" v-model="formData.ableToHelp" />
                    <label for="able-to-help" class="toggle">I can help</label>
                    <input id="unable-to-help" name="able-to-help" class="toggle" type="radio" :value="false" v-model="formData.ableToHelp" />
                    <label for="unable-to-help" class="toggle">Sorry, I cannot help</label>
                </div>
            </fieldset>

            <div class="reply" v-if="formData.ableToHelp !== null">
                <div class="reply__buttons">
                    <img :src="`/images/avatar/${user.id}`" alt="" class="avatar avatar--small">
                    <input id="has-attachments" name="has-attachments" class="toggle" type="checkbox" :value="true" v-model="formData.hasAttachments" />
                    <label for="has-attachments"><SvgIcon :icon="'link'"/><span class="sr-only">Add Attachment</span></label>
                </div>
                <fieldset class="reply__fields">
                    <div class="form__group">
                        <textarea v-model="formData.content" class="form__control" placeholder="Enter your response here..."></textarea>
                    </div>
                    <div class="form__group" v-show="formData.hasAttachments">
                        <FileUpload id="documents" v-model="formData.documents" name="documents" :multiple="true">
                        </FileUpload>
                    </div>
                    <div class="form__group">
                        <button class="btn btn--primary">Save</button>
                    </div>
                </fieldset>
            </div>

            <div class="form__group form__group--submit-fixed" ref="bar" v-else>
                <label for="able-to-help" @click="scrollToForm" class="btn">I can help</label>
                <label for="unable-to-help" @click="scrollToForm" class="btn">Sorry, I cannot help</label>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import API from '../../../api';
    import SvgIcon from '../../SvgIcon';
    import FileUpload from '../../Form/FileUpload';

    export default {
    	name: 'OpportunityResponseForm',
	    components: {
		    FileUpload,
		    SvgIcon
        },
	    props: {
    	    opportunity: {
    	    	type: Number,
                required: true,
            },
        },
        data() {
    	    return {
		        formData: {
			        ableToHelp: null,
			        hasAttachments: null,
			        content: '',
		        }
            }
        },
        computed: {
	        ...mapState({
		        user: state => state.auth.user,
	        }),
        },
        methods: {
	        scrollToForm() {
		        this.$refs.form.scrollIntoView({ behavior: 'smooth', block: 'start' });
	        },
	        onSubmit() {
                const eventCategory = typeof this.formData.id !== 'undefined' ? "update" : "create";
                if(window.gtag) {
                    const eventLabel = this.formData.ableToHelp ? "able_to_help" : "unable_to_help";
                    console.log(`Submitting opportunity feedback, category ${eventCategory} label ${eventLabel}`)
                    window.gtag("event", "opportunity_feedback", {
                        "event_category": eventCategory,
                        "event_label": eventLabel
                    });
                }

	            if(typeof this.formData.id !== 'undefined'){
                    API.updateOpportunityResponse(this.opportunity, this.formData.id, this.formData).then(response => this.resetForm(response, 'update'));
                } else{
                    API.setOpportunityResponse(this.opportunity, this.formData).then(response => this.resetForm(response, 'submitted'));
                }
	        },
            resetForm(response, type){
	            console.log(response);
                this.$emit(type, response);

                if(!this.formData.ableToHelp) {
                    this.$modal.show('dialog', {
                        title: 'Thanks',
                        text: 'This opportunity has now been removed from your dashboard. You can access it under the Opportunities tab on the left.',
                        buttons: [
                            {
                                title: 'Close',
                                handler: () => {
                                    this.$modal.hide('dialog');
                                }
                            },
                        ]
                    });
                }

                this.formData = {
                    ableToHelp: null,
                    hasAttachments: null,
                    content: '',
                };
                this.$refs.form.reset();
            }
        },

    }
</script>

<style lang="scss">
    .response-form{
        .form__group{
            button{
                align-self: flex-end;
            }
        }
    }

    .reply{
        display: flex;

        &__buttons{
            width: 4rem;
            flex-grow: 0;
            margin-right: 2rem;

            label{
                width: 100%;
                display: block;
                margin-top: 1rem;

                svg{
                    display: block;
                    margin: 0 auto;
                }
            }
        }

        &__fields{
            flex-grow: 1;
        }
    }
</style>

